import { Component, Output, EventEmitter, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../../services/form-field-control.service';
import { FormField } from '../../../shared/form-field/form-field';
import { ElectroluxModalService } from './electrolux-modal.service';
import { EmailService } from '../../../services/email.service';
import { MessageService } from 'primeng/api';
import { ChangeDetectorRef } from '@angular/core';
import { ElectroluxTableService } from './electrolux-table/electrolux-table.service';
import { ServiceOrderService } from '../service-order.service';
import { ServiceOrderDataService } from '../service-order-data.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'electrolux-modal',
  templateUrl: 'electrolux-modal.template.html',
  styleUrls: ['./electrolux-modal.scss'],
  providers: [
    FormFieldControlService,
    ElectroluxModalService,
    EmailService,
    MessageService,
    ElectroluxTableService,
  ],
})
export class ElectroluxModalComponent implements OnInit, OnDestroy {
  private privateDisplayDialog: boolean;
  @Input() modalTitle: string;
  @Input() set displayDialog(value: boolean) {
    this.privateDisplayDialog = value;
    this.displayDialogChange.emit(this.displayDialog);
  }
  get displayDialog(): boolean {
    return this.privateDisplayDialog;
  }
  @Input() isReschedule = false;
  @Input() isCancel = false;
  @Output() formSubmitEvent = new EventEmitter<any>();
  @Output() formValueChanged: EventEmitter<boolean> = new EventEmitter();
  @Output() displayDialogChange = new EventEmitter();

  formFields: FormField<string>[] = [];
  form: FormGroup;

  formFields1: FormField<string>[] = [];
  formFields2: FormField<string>[] = [];
  displayElectroluxModal: true;
  isLoading = false;
  isDisabled = false;
  querySubscriptions: Subscription[] = [];

  constructor(
    private qcs: FormFieldControlService,
    private electroluxModalService: ElectroluxModalService,
    private serviceOrderService: ServiceOrderService,
    private serviceOrderDataService: ServiceOrderDataService,
    private emailService: EmailService,
    private messageService: MessageService,
    private chRef: ChangeDetectorRef,
    private elxTableService: ElectroluxTableService,
  ) {
    this.electroluxModalService.getSendEmailFields().subscribe((data) => {
      this.formFields = data;
    });
  }
  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.formFields);
    this.formFields1 = this.formFields.slice(0, 6);
    this.formFields2 = this.formFields.slice(11, 30);
    this.form.valueChanges.subscribe((x) => {
      this.formValueChanged.emit(true);
    });
  }
  onSubmit() {
    if (this.isDisabled) {
      return;
    }
    if (this.elxTableService.selectedValue.length === 0) {
      window.alert('No Timeslot Selected');
      return;
    }
    this.isDisabled = true;
    this.isLoading = true;
    this.querySubscriptions.push(
      this.elxTableService
        .bookAppointment(this.elxTableService.selectedValue, this.isReschedule, this.isCancel)
        .subscribe(
          (data: any) => {
            const isSuccess = data && (data.status === 'success' || data.returnType === 'Success');

            if (isSuccess) {
              // next getElectroluxCallStatus to clear skip flag (appointment status is not auto-called from there).
              this.serviceOrderDataService.electroluxModal.skipImmediateElectroluxAppointmentStatusOnce = true;
              const ebsDispatchNo =
                data?.ebsDispatchNo || data?.electroluxResponse?.ebsDispatchNo || null;
              if (ebsDispatchNo) {
                this.serviceOrderDataService.electroluxModal.ebsDispatchNo = ebsDispatchNo;
              }
              const br = data?.bookingResult;
              const bookedWo = String(
                br?.electroluxResponse?.ebsDispatchNo ||
                data?.electroluxResponse?.ebsDispatchNo ||
                br?.electroluxResponse?.CallStatus?.EluxWorkorderNo ||
                  br?.EluxWorkorderNo ||
                  '',
              ).trim();
              if (bookedWo) {
                this.serviceOrderDataService.electroluxModal.eluxWorkorderNo = bookedWo;
              }
              const sel = this.elxTableService.selectedValue as {
                availableDate?: string;
                scheduledDate?: string;
                timePeriod?: string;
              };
              const sd = sel?.scheduledDate ?? sel?.availableDate;
              const tp = sel?.timePeriod;
              if (sd != null && String(sd).trim() !== '') {
                const modal = this.serviceOrderDataService.electroluxModal;
                const prev = modal.scheduleCallDetails;
                modal.scheduleCallDetails = {
                  ...(typeof prev === 'object' && prev ? prev : {}),
                  serviceType: 'Electrolux',
                  scheduledDate: sd,
                  ...(tp != null && String(tp).trim() !== '' ? { timePeriod: String(tp) } : {}),
                };
              }
              if (br) {
                const refNo = String(
                  br.requestorDispatchNum ??
                    br.requestorDispatchNumber ??
                    br.electroluxResponse?.CallStatus?.RequestorDispatchNum ??
                    br.electroluxResponse?.CallStatus?.CallNo ??
                    '',
                ).trim();
                if (refNo.toUpperCase().includes('-R')) {
                  const modal = this.serviceOrderDataService.electroluxModal;
                  const prevElx = modal.elxCallStatusDetails;
                  const so =
                    this.serviceOrderDataService.serviceOrderDataModel.claimData?.serviceOrderNumber;
                  modal.elxCallStatusDetails = {
                    ...(typeof prevElx === 'object' && prevElx ? prevElx : {}),
                    ...(so ? { serviceOrderNumber: so } : {}),
                    callNo: refNo,
                  };
                }
              }
              if (data.isClaimDataChanged) {
                this.serviceOrderService.claimDataChanged.next(true);
              }
              if (data.isNoteChanged) {
                this.serviceOrderService.claimNotesChanged.next(true);
              }
              this.isLoading = false;
              this.serviceOrderDataService.serviceOrderDataModel.isThirdPartyDispatch = true;
              // Pass isClaimDataChanged so parent can skip duplicate refreshClaimProfile (avoids double getElectroluxCallStatus / appointment status).
              this.formSubmitEvent.emit({
                success: true,
                isClaimDataChanged: !!data.isClaimDataChanged,
              });
              this.displayDialog = false;
            } else {
              this.isLoading = false;
              this.isDisabled = false;

              // Handle partial_failure - cancellation succeeded but booking failed (reschedule scenario)
              if (data && data.status === 'partial_failure') {
                // Process claim changes since cancellation succeeded
                if (data.isClaimDataChanged) {
                  this.serviceOrderService.claimDataChanged.next(true);
                }
                if (data.isNoteChanged) {
                  this.serviceOrderService.claimNotesChanged.next(true);
                }
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Partial Failure',
                  detail: data.message || 'Cancellation succeeded but booking failed. Please try booking again.',
                  sticky: true,
                });
              } else {
                // Full failure
                const errorMsg = data && data.message ? data.message : 'Error while booking appointment. Please try again or contact support.';
                this.messageService.add({
                  severity: 'error',
                  summary: 'Booking Failed',
                  detail: errorMsg,
                });
              }
            }
          },
          (err) => {
            this.isLoading = false;
            this.isDisabled = false;
            const errorDetail = err?.error?.message || err?.message || 'Unable to complete booking. Please check your connection and try again.';
            this.messageService.add({
              severity: 'error',
              summary: 'Booking Failed',
              detail: errorDetail,
            });
          },
        ),
    );
  }

  onReschedule() {
    this.onSubmit();
  }

  onCancel() {
    this.serviceOrderDataService.serviceOrderDataModel.servicerInfo = null;
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
  }

  ngOnDestroy() {
    this.querySubscriptions.forEach((subs) => subs.unsubscribe());
  }
}
